import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Education } from '../../portfolio.data';
import { RevealDirective } from '../../directives/reveal.directive';

@Component({
  selector: 'app-education',
  standalone: true,
  imports: [CommonModule, RevealDirective],
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.scss']
})
export class EducationComponent {
  @Input({ required: true }) education!: Education[];
}
